import { render, staticRenderFns } from "./TrainAgency.vue?vue&type=template&id=74cea3ed&"
import script from "./TrainAgency.vue?vue&type=script&lang=js&"
export * from "./TrainAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports